import {useCallback} from 'react';
import {useContext} from 'use-context-selector';
import {LocalContext} from '../context/LocalContext';
import createUUID from './createUUID';

const useCreateClientStatusMessage = () => {
    const [localData, setLocalData] = useContext(LocalContext);

    const handleCreateClientStatusMessage = useCallback((messageData, reset, localDataModified) => {
        const newMessages = (reset ? [] : [...localData.clientStatusMessages]);
        const newMessage = {...messageData, uuid: createUUID()};
        newMessages.push(newMessage);
        if (!localDataModified) {
            setLocalData({
                ...localData, clientStatusMessages: [...newMessages]
            });
        } else {
            setLocalData({
                ...localDataModified, clientStatusMessages: [...newMessages]
            });
        }
    }, [localData, setLocalData]);

    return handleCreateClientStatusMessage;
}

export default useCreateClientStatusMessage;
